// import { useState, useEffect } from "react";
// import Navbar from "../Side-Navbar/Navbar";
// import Sidebar from "../Side-Navbar/Sidebar";
// import CommandMenu from "../CommandMenu/CommandMenu"; // 🟢 CommandMenu imported here

// function MainLayout({ children }) {
//   const [sidebarMode, setSidebarMode] = useState("lead");
//   const [isSidebarOpen, setIsSidebarOpen] = useState(
//     localStorage.getItem('sidebarOpen') === 'true' && window.innerWidth >= 1024
//   );

//   useEffect(() => {
//     const handleResize = () => {
//       if (window.innerWidth < 1024) {
//         setIsSidebarOpen(false);
//         localStorage.setItem('sidebarOpen', false);
//       }
//     };
//     handleResize();
//     window.addEventListener('resize', handleResize);
//     return () => window.removeEventListener('resize', handleResize);
//   }, []);

//   const handleToggleSidebarMode = (newMode) => {
//     setSidebarMode(newMode);
//   };

//   const toggleSidebar = () => {
//     const newState = !isSidebarOpen;
//     setIsSidebarOpen(newState);
//     localStorage.setItem('sidebarOpen', newState);
//   };

//   return (
//     <div className="min-h-screen bg-gray-100 dark:bg-gray-800 flex">
      
//       {/* 🟢 Command Menu Mounted Here */}
//       <CommandMenu /> 

//       {/* Fixed Sidebar */}
//       <div className={`fixed inset-y-0 left-0 z-40 ${isSidebarOpen ? 'w-64' : 'w-0'} transition-all duration-300 dark:bg-gray-800 overflow-hidden`}>
//         <Sidebar 
//           mode={sidebarMode} 
//           isOpen={isSidebarOpen} 
//           onToggle={toggleSidebar} 
//         />
//       </div>
      
//       {/* Main content area */}
//       <div className={`flex-1 flex flex-col  min-w-0 ${isSidebarOpen ? 'lg:ml-64' : 'ml-0'}`}>
//         <div className="flex-shrink-0 ">
//           <Navbar 
//             onToggleSidebarMode={handleToggleSidebarMode} 
//             isSidebarOpen={isSidebarOpen}
//             onToggleSidebar={toggleSidebar}
//           />
//         </div>
        
//         <div className="flex-1 overflow-auto">
//           {children}
//         </div>
//       </div>
//     </div>
//   );
// }

// export default MainLayout;




// import { useState, useEffect } from "react";
// import Navbar from "../Side-Navbar/Navbar";
// import Sidebar from "../Side-Navbar/Sidebar";
// import CommandMenu from "../CommandMenu/CommandMenu";

// function MainLayout({ children }) {
//   const [sidebarMode, setSidebarMode] = useState("lead");
//   const [isSidebarOpen, setIsSidebarOpen] = useState(
//     localStorage.getItem('sidebarOpen') === 'true' && window.innerWidth >= 1024
//   );

//   useEffect(() => {
//     const handleResize = () => {
//       if (window.innerWidth < 1024) {
//         setIsSidebarOpen(false);
//       }
//     };
//     handleResize();
//     window.addEventListener('resize', handleResize);
//     return () => window.removeEventListener('resize', handleResize);
//   }, []);

//   const handleToggleSidebarMode = (newMode) => {
//     setSidebarMode(newMode);
//   };

//   const toggleSidebar = () => {
//     const newState = !isSidebarOpen;
//     setIsSidebarOpen(newState);
//     localStorage.setItem('sidebarOpen', newState);
//   };

//   return (
//     <div className="min-h-screen bg-gray-100 dark:bg-gray-800 flex overflow-hidden">
      
//       {/* 🟢 Command Menu Mounted Here */}
//       <CommandMenu /> 

//     {/* Fixed Sidebar Wrapper */}
//       {/* Note: Desktop pe w-20 rakha hai for collapsed state */}
//       <div className={`fixed inset-y-0 left-0 z-[60] transition-all duration-300 dark:bg-gray-800 ${
//         isSidebarOpen ? 'w-64' : 'w-0 lg:w-20'
//       }`}>
//         <Sidebar 
//           mode={sidebarMode} 
//           isOpen={isSidebarOpen} 
//           onToggle={toggleSidebar} 
//         />
//       </div>
      
//       {/* Main content area */}
//       {/* Note: Margin-left (ml) ko w-20 ke according adjust kiya gaya hai */}
//       <div className={`flex-1 flex flex-col min-w-0 transition-all duration-300 ${
//         isSidebarOpen ? 'lg:ml-64' : 'ml-0 lg:ml-20'
//       }`}>
//         <div className="flex-shrink-0">
//           <Navbar 
//             onToggleSidebarMode={handleToggleSidebarMode} 
//             isSidebarOpen={isSidebarOpen}
//             onToggleSidebar={toggleSidebar}
//           />
//         </div>
        
//         <div className="flex-1">
//           {children}
//         </div>
//       </div>
//     </div>
//   );
// }

// export default MainLayout;






// import { useState, useEffect } from "react";
// import Navbar from "../Side-Navbar/Navbar";
// import Sidebar from "../Side-Navbar/Sidebar";
// import CommandMenu from "../CommandMenu/CommandMenu";

// function MainLayout({ children }) {
//   const [sidebarMode, setSidebarMode] = useState("lead");
//   const [isSidebarOpen, setIsSidebarOpen] = useState(
//     localStorage.getItem('sidebarOpen') === 'true' && window.innerWidth >= 1024
//   );

//   useEffect(() => {
//     const handleResize = () => {
//       if (window.innerWidth < 1024) {
//         setIsSidebarOpen(false);
//       }
//     };
//     handleResize();
//     window.addEventListener('resize', handleResize);
//     return () => window.removeEventListener('resize', handleResize);
//   }, []);

//   const handleToggleSidebarMode = (newMode) => {
//     setSidebarMode(newMode);
//   };

//   const toggleSidebar = () => {
//     const newState = !isSidebarOpen;
//     setIsSidebarOpen(newState);
//     localStorage.setItem('sidebarOpen', newState);
//   };

//   return (
//     <div className="h-screen bg-gray-100 dark:bg-gray-800 flex overflow-hidden">
      
//       {/* 🟢 Command Menu Mounted Here */}
//       <CommandMenu /> 

//       {/* Fixed Sidebar Wrapper */}
//       <div className={`fixed inset-y-0 left-0 z-[60] transition-all duration-300 dark:bg-gray-800 ${
//         isSidebarOpen ? 'w-64' : 'w-0 lg:w-20'
//       }`}>
//         <Sidebar 
//           mode={sidebarMode} 
//           isOpen={isSidebarOpen} 
//           onToggle={toggleSidebar} 
//         />
//       </div>
      
//       {/* Main content area */}
//       <div className={`flex-1 flex flex-col min-w-0 transition-all duration-300 ${
//         isSidebarOpen ? 'lg:ml-64' : 'ml-0 lg:ml-20'
//       }`}>
        
//         {/* Navbar Wrapper - z-50 taaki ye content ke upar rahe */}
//         <div className="flex-shrink-0 z-50">
//           <Navbar 
//             onToggleSidebarMode={handleToggleSidebarMode} 
//             isSidebarOpen={isSidebarOpen}
//             onToggleSidebar={toggleSidebar}
//           />
//         </div>
        
//         {/* Content area jo scroll hoga */}
//         <div className="flex-1 overflow-y-auto">
//           {children}
//         </div>
//       </div>
//     </div>
//   );
// }

// export default MainLayout;







import { useState, useEffect } from "react";
import Navbar from "../Side-Navbar/Navbar";
import Sidebar from "../Side-Navbar/Sidebar";
import CommandMenu from "../CommandMenu/CommandMenu";
import Chatbot from "../Chatbot/chatbott";
import { ChatbotPageProvider } from "../Chatbot/integration/PageContext";
// 👇 Chatbot import karein (Apna sahi path check kar lein)


function MainLayout({ children }) {
  const [sidebarMode, setSidebarMode] = useState("lead");
  const [isSidebarOpen, setIsSidebarOpen] = useState(
    localStorage.getItem('sidebarOpen') === 'true' && window.innerWidth >= 1024
  );

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 1024) {
        setIsSidebarOpen(false);
      }
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleToggleSidebarMode = (newMode) => {
    setSidebarMode(newMode);
  };

  const toggleSidebar = () => {
    const newState = !isSidebarOpen;
    setIsSidebarOpen(newState);
    localStorage.setItem('sidebarOpen', newState);
  };

  return (
    <ChatbotPageProvider>
    {/* 👇 Added 'relative' class to ensure floating chatbot stays inside viewport */}
    <div className="relative h-screen bg-gray-100 dark:bg-gray-800 flex overflow-hidden">
      
      {/* 🟢 Command Menu Mounted Here */}
      <CommandMenu /> 

      {/* Fixed Sidebar Wrapper */}
      <div className={`fixed inset-y-0 left-0 z-[60] transition-all duration-300 dark:bg-gray-800 ${
        isSidebarOpen ? 'w-64' : 'w-0 lg:w-20'
      }`}>
        <Sidebar 
          mode={sidebarMode} 
          isOpen={isSidebarOpen} 
          onToggle={toggleSidebar} 
        />
      </div>
      
      {/* Main content area */}
      <div className={`flex-1 flex flex-col min-w-0 transition-all duration-300 ${
        isSidebarOpen ? 'lg:ml-64' : 'ml-0 lg:ml-20'
      }`}>
        
        {/* Navbar Wrapper - z-50 taaki ye content ke upar rahe */}
        <div className="flex-shrink-0 z-50">
          <Navbar 
            onToggleSidebarMode={handleToggleSidebarMode} 
            isSidebarOpen={isSidebarOpen}
            onToggleSidebar={toggleSidebar}
          />
        </div>
        
        {/* Content area jo scroll hoga */}
        <div className="flex-1 overflow-y-auto">
          {children}
        </div>
      </div>

      {/* 🟢 Chatbot Mounted Here (Sabse upar overlap karega) */}
      <Chatbot />

    </div>
    </ChatbotPageProvider>
  );
}

export default MainLayout;